import { compile, compileG } from "./compile/emit.js";
import { DOT, DOT_G } from "./compile/templates.js";
import { vop } from "./vop.js";
const $ = (dim) => dot.add(dim, compile(dim, DOT, "a,b", void 0, "", "+", "return ", ";"));
const dot = vop();
dot.default(compileG(DOT_G, "a,b", void 0, "s", "let s=0;"));
const dot2 = $(2);
const dot3 = $(3);
const dot4 = $(4);
export {
  dot,
  dot2,
  dot3,
  dot4
};
